"use client";

import { Moon, Sun } from "lucide-react";
import { ThemeProvider, useTheme } from "next-themes";
import { useEffect, useState } from "react";

type ThemeProviderProps = {
  children: React.ReactNode;
};

export const AppThemeProvider = ({ children }: ThemeProviderProps) => {
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      {children}
    </ThemeProvider>
  );
};

const DarkModeToggle = () => {
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <button
        type="button"
        className="rounded-full border border-brand-border p-2 text-transparent"
        aria-label="تبديل الوضع"
        aria-hidden="true"
        tabIndex={-1}
      >
        <span className="inline-block h-5 w-5" />
      </button>
    );
  }

  const isDark = resolvedTheme === "dark";

  return (
    <button
      type="button"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      className="rounded-full border border-brand-border bg-brand-surface p-2 text-brand-text transition hover:border-brand-red"
      aria-label="تبديل الوضع"
      title="تبديل الوضع"
    >
      {isDark ? (
        <Sun className="h-5 w-5 rtl-icon" />
      ) : (
        <Moon className="h-5 w-5 rtl-icon" />
      )}
    </button>
  );
};

export default DarkModeToggle;
